<template>
  <q-layout view="lHh Lpr lFf">
    <Header />
    <q-page-container>
      <q-page padding>
      </q-page>
    </q-page-container>
  </q-layout>
</template>

<script>
import Header from '~/components/Header';
import { loginFromAdminBackoffice, getUser } from '~/services/user';
import { notifyGlobalError } from '~/services/notify';
import { setJWT, removeJwt } from '~/services/api';

export default {
  name: 'IframeBackofficeConnection',
  components: {
    Header,
  },
  created() {
    this.cancelAuthentication()
    this.$q.loading.show({
      message: 'Tentative de connexion en cours'
    })

    setTimeout(() => {
      if (!this.success) {
        this.$router.push({name: 'Page404'});
        this.$q.loading.hide()
      }
      
    }, 10000)
    window.addEventListener('message', (event) => {
      if (event.data.call && event.data.call === "sendAuthenticationAuthorization") {
        this.payload = {
          "subscriptionId": event.data.subscriptionId,
          "subscriptionHash": event.data.subscriptionHash
        }
        this.subscriptionId = event.data.subscription_id
        this.subscriptionHash = event.data.subscription_hash
        this.success = true
        this.callLoginUrl()
      }
    });
  },
  mounted() {
    
  },
  data() {
    return {
      success: false,
      payload: {},
    };
  },
  methods: {
    async callLoginUrl() {
      await loginFromAdminBackoffice(this.payload).then((response) => {
        if (response.status != 200) {
          this.notifyLoginError()
        } else {
          this.authenticate(response.data.access, response.data.refresh);
        }
      });
    },
    async authenticate(accessToken, refreshToken) {
      this.$store.commit('user/setIsAuthenticated', true)
      this.$store.commit('user/setAccessToken', accessToken)
      this.$store.commit('user/setRefreshToken', refreshToken)
      setJWT(accessToken);
      const resp = await getUser()
        .then((response) => {
          if (response.status != 200) {
            this.notifyLoginError();
            this.cancelAuthentication();
          }
          else {
            this.$store.commit('user/setUser', response.data);
            this.$router.push({name: 'dashboard'});
          }
        })
        .catch(() => {
          this.cancelAuthentication();
        }).finally(() => {
          this.$q.loading.hide()
        })
    },
    async cancelAuthentication(){
      this.$store.commit('user/unsetUser');
      removeJwt();
    },
    async notifyLoginError(){
      notifyGlobalError('Connexion impossible (vérifiez vos identifiants).');
    }
  }
};
</script>
  